import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
  },
  container: {
    padding: theme.spacing(2),
    maxWidth: 1200,
    margin: "0 auto",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
  },
  header: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  // Estilos responsivos adicionais
  [theme.breakpoints.down("sm")]: {
    container: {
      padding: theme.spacing(1),
    },
    header: {
      padding: theme.spacing(1.5),
    },
  },
}));

export default useStyles;
